import { fetchApi } from '../client';

export interface HealthPackage {
  id: string;
  clinicId: string;
  name: string;
  description?: string;
  price: number;
  validityDays: number;
  consultationCredits: number;
  labDiscountPct: number;
  medicineDiscountPct: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PackageEnrollment {
  id: string;
  clinicId: string;
  packageId: string;
  patientId: string;
  enrolledAt: string;
  expiresAt: string;
  remainingConsultations: number;
  status: 'ACTIVE' | 'EXPIRED' | 'CANCELLED';
  billId?: string;
}

export interface EnrollmentSummary {
  activeEnrollments: number;
  activePackages: number;
}

export const healthPackagesModule = {
  list: (activeOnly = true) =>
    fetchApi<HealthPackage[]>(`/api/health-packages?activeOnly=${activeOnly}`),

  create: (pkg: Omit<HealthPackage, 'id' | 'clinicId' | 'createdAt' | 'updatedAt'>) =>
    fetchApi<HealthPackage>('/api/health-packages', {
      method: 'POST',
      body: JSON.stringify(pkg),
    }),

  update: (id: string, pkg: Partial<HealthPackage>) =>
    fetchApi<HealthPackage>(`/api/health-packages/${id}`, {
      method: 'PUT',
      body: JSON.stringify(pkg),
    }),

  deactivate: (id: string) =>
    fetchApi<{ message: string }>(`/api/health-packages/${id}`, { method: 'DELETE' }),

  enroll: (packageId: string, patientId: string, billId?: string) =>
    fetchApi<PackageEnrollment>(`/api/health-packages/${packageId}/enroll`, {
      method: 'POST',
      body: JSON.stringify({ patientId, billId }),
    }),

  getEnrollments: (patientId: string) =>
    fetchApi<PackageEnrollment[]>(`/api/health-packages/enrollments/${patientId}`),

  useCredit: (enrollmentId: string) =>
    fetchApi<PackageEnrollment>(`/api/health-packages/enrollments/${enrollmentId}/use-credit`, {
      method: 'POST',
    }),

  cancelEnrollment: (enrollmentId: string) =>
    fetchApi<{ message: string }>(`/api/health-packages/enrollments/${enrollmentId}`, { method: 'DELETE' }),

  getSummary: () =>
    fetchApi<EnrollmentSummary>('/api/health-packages/summary'),
};
